import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import UserBase from '../components/Management/UserBase';
import ListingDescriptions from '../components/Management/ListingDescriptions.jsx';
import TabNavigation from '../components/TabNavigation.jsx';
import BillingTab from '../components/Management/Billing.jsx';
import Integrations from '../components/Management/Integrations.jsx';
import CatalogPageShell from '../components/Products/CatalogPageShell.jsx';

export default function ManageAccount() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [value, setValue] = useState(() => {
        const pageIndex = Number(searchParams.get("page"))
        return Number.isFinite(pageIndex) && pageIndex > 0 ? pageIndex - 1 : 0
    });

    const handleChange = (event, newValue) => {
        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.set('page', newValue + 1)
            return newParams;
        })
        setValue(newValue);
    };

    useEffect(() => {
        if (searchParams.get("code")) {
            setValue(3)
            return
        }
        const pageIndex = searchParams.get("page")
        if (pageIndex !== null) {
            setValue(Number(pageIndex) - 1)
        }
    }, [searchParams])

    const tabPage = (index) => {
        switch (index) {
            case 0:
                return <UserBase />
            case 1:
                return <ListingDescriptions />
            case 2:
                return <BillingTab />
            case 3:
                return <Integrations />
            default:
                return <UserBase />;
        }
    }

    const TABS_CONFIG = [
        { label: 'App Users', value: 0 },
        { label: 'Listing Descriptions', value: 1 },
        { label: 'Billing', value: 2 },
        { label: 'Integrations', value: 3 },
    ].filter(Boolean);

    return (
        <CatalogPageShell title="Manage">
            <div className="app-page-stack">
                <div style={{ flexShrink: 0 }}>
                    <TabNavigation
                        value={value}
                        onChange={(e, val) => handleChange(e, val)}
                        tabs={TABS_CONFIG}
                    />
                </div>
                {tabPage(value)}
            </div>
        </CatalogPageShell>
    )
}
